// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:768px){._7ekuh{position:relative;width:35.5rem}}@media(max-width:767px){._7ekuh{height:calc(100% - 2rem);position:fixed}}._27Mkc{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;grid-gap:16px;gap:16px;grid-gap:1rem;gap:1rem;width:100%}@media(min-width:768px){._27Mkc{padding:1.5rem 1.75rem .5rem;max-height:calc(100vh - 16rem);overflow-y:auto}}@media(max-width:767px){._27Mkc{-ms-flex-align:start;align-items:flex-start;height:100%}}._2VSEN{position:absolute;bottom:-48px;bottom:-3rem;width:100%;margin-left:-1.5rem;text-align:center;text-transform:uppercase;color:#fff;cursor:pointer;font-size:14px;font-size:.875rem;font-size:16px;font-weight:500;line-height:20px;font-family:var(--heading-font);letter-spacing:.5px}@media(max-width:767px){._2VSEN{display:none}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"baseModalContent": "_7ekuh",
	"root": "_27Mkc",
	"closeButton": "_2VSEN"
};
module.exports = exports;
